export const virtualQRByLocationId = {

    GET_VIRTUALQRByLocationId: "GET_VIRTUALQRByLocationId"
}
